import { z } from 'zod'
import { parseTimestamp } from '@/util/zod/validators'
import { ClientAgentEventReadSchema } from '@/agent/events/store/schemas'
import { ArtifactVersionReadSchema } from '@/artifacts/schemas'
import { AgentResponseMetadataReadSchema } from '@/agent/response_metadata/store/schemas'
import { AgentAssistantRequestParamsSchema } from '@/agent/chat_form/store/schemas'
import { ClientAgentReferenceSchema } from '@/agent/references/store/schemas'
import { ArtifactTemplateSelectionReadSchema, ArtifactVersionAppliedTemplateReadSchema } from '@/artifact-templates/schemas'

// Based on the backend AgentConversationRead model
export const AgentConversationReadSchema = z.object({
  id: z.string().uuid(),
  user_id: z.string(),
  title: z.string(),
  is_hidden: z.boolean(),
  updated_at: z.preprocess((val, ctx) => parseTimestamp(val, ctx), z.number()),
  matter_id: z.string().uuid().nullable(),
})
export type AgentConversationRead = z.infer<typeof AgentConversationReadSchema>

// Zod schema for GetUserConversationsResponse
export const GetAgentConversationsResponseSchema = z.object({
  conversations: z.array(AgentConversationReadSchema),
})
export type GetAgentConversationsResponse = z.infer<typeof GetAgentConversationsResponseSchema>

// Based on the backend GetConversationDataResponse model
export const GetAgentConversationDataResponseSchema = z.object({
  conversation: AgentConversationReadSchema,
  events: z.array(ClientAgentEventReadSchema),
  artifact_versions: z.array(ArtifactVersionReadSchema),
  response_metadata: z.array(AgentResponseMetadataReadSchema),
  references: z.array(ClientAgentReferenceSchema).nullable(),
  latest_request_params: AgentAssistantRequestParamsSchema.nullable(),
  // One entry per artifact with a sticky template selection, and one per version that has had
  // a template applied. Keyed by id on the FE; merged into the artifact-templates store on load.
  template_selections: z.array(ArtifactTemplateSelectionReadSchema),
  applied_templates: z.array(ArtifactVersionAppliedTemplateReadSchema),
})

export type GetAgentConversationDataResponse = z.infer<typeof GetAgentConversationDataResponseSchema>

// Based on the backend CreateFollowUpQuestionsResponse model
export const CreateFollowUpQuestionsResponseSchema = z.object({
  questions: z.array(z.string()),
})

export type CreateFollowUpQuestionsResponse = z.infer<typeof CreateFollowUpQuestionsResponseSchema>
